var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessExpand({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 0L11.1222 1.78889L8.87444 4.02111L9.97889 5.12556L12.2111 2.87778L14 4.66667V0H9.33333ZM0 4.66667L1.78889 2.87778L4.02111 5.12556L5.12556 4.02111L2.87778 1.78889L4.66667 0H0V4.66667ZM4.66667 14L2.87778 12.2111L5.12556 9.97889L4.02111 8.87444L1.78889 11.1222L0 9.33333V14H4.66667ZM14 9.33333L12.2111 11.1222L9.97889 8.87444L8.87444 9.97889L11.1222 12.2111L9.33333 14H14V9.33333Z",
    fill: "#6E6E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessExpand);
export default __webpack_public_path__ + "static/media/process-expand.b26ef517a092a2e4ef5f43decaf32e25.svg";
export { ForwardRef as ReactComponent };